import { Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@material-ui/core';
import React, { Component } from 'react';

class CarRow extends Component {
    render() {
        return (
            <div className='flex-form'>
                <TableContainer component={Paper}>
                    <Table size="small" aria-label="a dense table">
                        <TableHead>
                            <TableRow>
                                <TableCell>Rendzsám</TableCell>
                                <TableCell>Megjegyzés</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            <TableRow key="new">
                                <TableCell> {this.props.row.licenseNumber}</TableCell>
                                <TableCell>{this.props.row.comment}</TableCell>
                            </TableRow>
                        </TableBody>
                    </Table>
                </TableContainer>
            </div>
        )
    }
}
export default CarRow;